import { STORY_SOURCE, story } from '@/content/storyBuilder'

// Written from the three-part full-page capture of
// digitopia.co/customers/bridgestone/ supplied on 2026-08-29 — "tıpatıp
// tastamam şekilde hazırla" — with the two photographs that run on it: the
// winter tyres the reference puts in the header, and the tyre on the open
// road it runs full width under the standfirst.
//
// Its shape is Federal Mogul's: a one-line lede, a standfirst about the
// company, a wide photograph, then four headed parts of left-ranged prose
// with no lists anywhere — which is what the reference does.
//
// The portrait in the closing card is the one already in the tree
// (`portrait-tekin-gulsen.png`, 900px), not the 600px file sent with the
// capture: same photograph, larger original.
export const added = story('bridgestone', 'Bridgestone', {
  lede: ['Becoming the “Digital Thermometer” of the Digital Transformation Journey.'],
  heroPhoto: {
    src: '/photo/bridgestone-winter-tyres.webp',
    alt: 'Four Bridgestone winter tyres on alloy wheels standing on a snowfield under a bright '
      + 'low sun, mountains behind them.',
  },
  intro: [
    'The Bridgestone Group is eternally committed to serving society with superior quality. '
    + 'The group will fulfill our responsibilities decisively. As you reach for the future, '
    + 'the Group will remain by your side. BriSA is the Turkish operations of Bridgestone. '
    + 'A joint venture between Bridgestone and Sabanci Group.',
  ],
  photo: {
    src: '/photo/bridgestone-tyre-open-road.webp',
    alt: 'A tyre seen tread-on in the middle of an empty country road running straight to the '
      + 'horizon between fields of dry grass.',
  },
  sections: [
    {
      heading: 'The Need?',
      body: [
        'The customer is running an organised digital transformation. They are progressing. '
        + 'But how to measure? They have multiple projects running in parallel. Which delivers '
        + 'value, which does not? In which areas the company is progressing? This needs '
        + 'external and unbiased review. They investigated into various methodologies, service '
        + 'providers, and such. Finally, they discovered Digitopia and the “Digital Maturity '
        + 'Index.” The independence, objectivity, professionalism, experience, and passion of '
        + 'Digitopia, convinced them. They don’t regret.',
      ],
    },
    {
      heading: 'The Solution',
      body: [
        'Digitopia measured the company’s digital maturity in 2019 and 2020 and will continue '
        + 'to do so. The customer side investment is attending to six assessment sessions. '
        + 'All relevant stakeholders are in one room / looking at one screen.',
        'The alignment, the learning, establishing a shared vision and common objectives is '
        + 'priceless. Getting a comprehensive report, recommendations, and a holistic roadmap '
        + 'are the output, but the benefits are much more than just the report.',
      ],
    },
    {
      heading: 'The Benefits',
      body: [
        'Now, BriSA knows where they stand. And actually, they scored seriously better than '
        + 'their industry average. Now, they are also able to set tangible and measurable '
        + 'targets and follow up, how they are progressing.',
      ],
    },
    {
      heading: 'The Next Steps',
      body: [
        'The customer engaged with Digitopia for the long-term. To be able to track the '
        + 'progress, staying with the same methodology makes sense, is very effective, and the '
        + 'company has adopted Digitopia’s terminology for internal purposes. Additionally, '
        + 'the teams are working on correlating digital maturity with business performance. '
        + 'They have engaged with various academic institutions to conduct rigorous research. '
        + 'The aim is to empirically prove the business value of digital transformation.',
      ],
    },
  ],
  check:
    'This page was written from a three-part screen capture of '
    + `${STORY_SOURCE}/bridgestone/ supplied on 2026-08-29, not from a file we hold, so please `
    + 'proofread it against the source — particularly the assessment years (2019 and 2020), '
    + '“six assessment sessions” and the claim that BriSA scored better than its industry '
    + 'average. Two spellings to confirm: the standfirst is verbatim from the reference, so it '
    + 'writes “Sabanci” and “BriSA” as that page does, and the closing card writes the speaker '
    + 'as “Tekin Gülşen” where the reference writes “TEKIN GULSEN” — the Turkish spelling is '
    + 'the one this site already uses for him on the Yazaki card. His title differs between '
    + 'the two cards (“CIO/IT Director, BriSA” here, “VP of IT Y-EMEA and Global Applications” '
    + 'on Yazaki’s); both are as their own reference pages give them, but somebody should say '
    + 'which is current. Two deliberate differences from the reference: it opens on a blue '
    + '“SUCCESS STORIES” eyebrow, which this template no longer draws on a customer’s own page '
    + '(asked for on 2026-08-29), and the header photograph is the 768×432 file the live site '
    + 'serves, so it will look soft on a high-density screen until a larger original arrives.',
})

/** Its place in the hand-placed order the imported Customers page set. */
export const order = 17
